<script setup>
import {onBeforeMount, onMounted} from 'vue'
import { useColorModes } from '@coreui/vue'
import { useThemeStore } from '@/helpers/theme.js'

const { isColorModeSet, setColorMode } = useColorModes(
  'coreui-free-vue-admin-template-theme',
)
const currentTheme = useThemeStore()


onBeforeMount(() => {
  const urlParams = new URLSearchParams(window.location.href.split('?')[1])
  let theme = urlParams.get('theme')

  if (theme !== null && theme.match(/^[A-Za-z0-9\s]+/)) {
    theme = theme.match(/^[A-Za-z0-9\s]+/)[0]
  }

  if (theme) {
    setColorMode(theme)
    return
  }

  if (isColorModeSet()) {
    return
  }

  setColorMode(currentTheme.theme)
})


// onMounted(() => {
//   const script = document.createElement('script');
//   script.src = 'https://vidu.my/player/play.js?v=' + Date.now();
//   script.async = true;
//   document.body.appendChild(script);
// });


</script>

<template>
<router-view v-slot="{ Component, route }">
  <component :is="Component" :key="route.fullPath" />
</router-view>
</template>

<style lang="scss">
@use 'styles/style';
</style>